const PlummePayrollCorrectionPresentation = (() => {
  const rows = (value: any): any[] => Array.isArray(value) ? value : [];
  const money = (value: number) => Math.round(value * 100) / 100;
  const postingDifference = (current: any[], baseline: any[]) => {
    const totals = new Map<string, any>();
    for (const [entries, factor] of [[current, 1], [baseline, -1]] as const) for (const row of rows(entries)) {
      const key = JSON.stringify([row.accountCode, row.employeeId || '', row.accrualYear || '']);
      const previous = totals.get(key) || { ...row, amount: 0 };
      previous.amount += factor * (Number(row.debit || 0) - Number(row.credit || 0)); totals.set(key, previous);
    }
    return [...totals.values()].map(entry => {
      const row = { ...entry }; delete row.amount;
      return { ...row, debit: Math.max(0, money(entry.amount)), credit: Math.max(0, -money(entry.amount)) };
    })
      .filter(row => row.debit > .005 || row.credit > .005);
  };
  const summary = (run: any, deltaRows: any[]) => {
    const baseline = rows(run.correctionBaselineLines);
    const full = rows(run.correctionLinesAreDelta ? run.correctionFullLines : run.lines);
    const sum = (lines: any[], key: string) => money(lines.reduce((total, line) => total + Number(line[key] || 0), 0));
    const result = [
      ['pay.grossPay', 'grossSalary'], ['pay.correctionNetClaim', 'netPay'], ['pay.tax', 'taxDeduction'],
      ['pay.correctionAga', 'employerContribution'], ['pay.holidayPay', 'holidayPayAccrual'], ['pay.correctionPensionAccrual', 'pensionContribution'],
    ].map(([label, key]) => ({ label, before: sum(baseline, key), after: sum(full, key), delta: money(sum(full, key) - sum(baseline, key)) }));
    const accountTotal = (entries: any[], code: string) => money(rows(entries).filter(row => row.accountCode === code).reduce((total, row) => total + Number(row.debit || 0) - Number(row.credit || 0), 0));
    const before = accountTotal(run.correctionBaselinePostingRows, '5410'), delta = accountTotal(deltaRows, '5410');
    result.push({ label: 'pay.correctionHolidayAga', before, after: money(before + delta), delta });
    return result;
  };
  const changePeriod = (draft: any, period: string) => ({ ...draft, period,
    paymentDate: String(draft.paymentDate || '').slice(0, 7) === period ? draft.paymentDate : `${period}-01` });
  return { postingDifference, summary, changePeriod };
})();
window.PlummePayrollCorrectionPresentation = PlummePayrollCorrectionPresentation;
